import { render, staticRenderFns } from "./cooperate.vue?vue&type=template&id=55ea5766&scoped=true"
import script from "./cooperate.vue?vue&type=script&lang=js"
export * from "./cooperate.vue?vue&type=script&lang=js"
import style0 from "./cooperate.vue?vue&type=style&index=0&id=55ea5766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea5766",
  null
  
)

export default component.exports